module.exports = __webpack_public_path__ + "img/se-office-skills.fa9aa1d5.png";